import React from "react";
import { Grid, Header } from "semantic-ui-react";
import { CustomContainer } from "../../custom-common";
import STRATEGIC_PARTNER from "../../../constants/strategicPartners";
import BenefitItem from "./benefitItem";


const Benefits = ({ benefits, riderLabels, infoIcon }) => {
    if (!benefits) return null;

    const categoryBenefits = [
        {
            key: 'moderate',
            label: 'Moderate',
            tooltip: "Injuries or illnesses that likely require a short visit to the ER or urgent care."
        },
        {
            key: 'severe',
            label: 'Severe',
            tooltip: "Serious conditions that require more intensive medical treatment and attention."
        },
        {
            key: 'catastrophic',
            label: 'Catastrophic',
            tooltip: "Dangerous or life-threatening conditions that require immediate medical intervention."
        }
    ];

    const riderBenefits = [
        {
            key: 'chronic',
            label: riderLabels.chronic,
            tooltip: `Coverage for over 4,100 additional ${riderLabels.chronic} conditions spanning asthma, diabetes, epilepsy, and many more.`
        },
        {
            key: 'mental',
            label: riderLabels.mental,
            tooltip: `Coverage for 600 different ${riderLabels.mental} health disorders like anxiety, bipolar, and depression.`
        },
        {
            key: 'maternity',
            label: riderLabels.maternity,
            tooltip: `Expands coverage to include an additional benefit category for nearly 2,300 covered ${riderLabels.maternity} conditions.`
        }
    ].filter(({ key }) => benefits[key]);

    const riderBenefitsLength = riderBenefits.length;

    return (
        <Grid>
            <Grid.Column width={7}>
                <Header as="h4" className="neutral900Text">Benefit categories</Header>
                <CustomContainer padded>
                    <Grid columns={3} stackable>
                        {categoryBenefits.map(({ key, label, tooltip }) => (
                            <BenefitItem
                                key={key}
                                label={label}
                                value={benefits[key]}
                                tooltipText={tooltip}
                                infoIcon={infoIcon}
                            />
                        ))}
                    </Grid>
                </CustomContainer>
            </Grid.Column>

            {riderBenefitsLength > 0 && (
                <Grid.Column width={riderBenefitsLength === 3 ? 7 : 6}>
                    <Header as="h4" className="neutral900Text">
                        {STRATEGIC_PARTNER.LABEL}<span style={{ color: "red" }}>+</span>
                    </Header>
                    <CustomContainer padded>
                        <Grid columns={riderBenefitsLength === 3 ? 3 : 2} stackable>
                            {riderBenefits.map(({ key, label, tooltip }) => (
                                <BenefitItem
                                    key={key}
                                    label={label}
                                    value={benefits[key]}
                                    tooltipText={tooltip}
                                    infoIcon={infoIcon}
                                />
                            ))}
                        </Grid>
                    </CustomContainer>
                </Grid.Column>
            )}
        </Grid>
    );
};

export default Benefits;
